import React from 'react';

import usePrefix from 'utils/usePrefix';
import { NoticeType } from 'utils/api/notice';
import { noticeTypes } from 'utils/constants';
import useDefaultFormikValue from 'utils/useDefaultFormikValue';
import FormikSelect, { FormikSelectOption } from 'components/FormikSelect';

interface Props {
  name: string;
  margin?: string;
  isDisabled?: boolean;
  defaultValue?: NoticeType;
}

const NoticeTypeSelect: React.FC<Props> = ({
  name,
  margin = '0',
  isDisabled = false,
  defaultValue,
}) => {
  const t = usePrefix('Notices');

  useDefaultFormikValue<NoticeType>(name, defaultValue);

  const typeOptions: Array<FormikSelectOption<NoticeType>> = [
    { value: noticeTypes.advice, label: t('ADVICE') },
    { value: noticeTypes.instruction, label: t('INSTRUCTION') },
    { value: noticeTypes.movie, label: t('MOVIE') },
    { value: noticeTypes.article, label: t('ARTICLE') },
    { value: noticeTypes.intervention_plan, label: t('INTERVENTION_PLAN') },
  ];

  return (
    <FormikSelect<NoticeType>
      name={name}
      label={t('type')}
      placeholder={t('type')}
      options={typeOptions}
      margin={margin}
      isDisabled={isDisabled}
    />
  );
};

export default NoticeTypeSelect;
